const projects = [
  {
    title: "WhatsaStore",
    description:
      "Lightweight SaaS CRM for small businesses using WhatsApp as their main sales and customer follow-up channel. Features include leads, contacts, products, orders, invoices, customer follow-up, dashboard and a browser extension concept.",
    tags: ["SaaS CRM", "WhatsApp workflow", "Small business"],
    links: {
      demo: "https://whatsastore.online/",
      github: null
    }
  },
  {
    title: "Sketchstash",
    description:
      "Developer knowledge base for saving commands, notes and technical snippets. Built for developers who want to store and reuse practical knowledge without losing it in terminal chaos.",
    tags: ["Developer tool", "Knowledge base", "Commands"],
    links: {
      demo: null,
      github: "https://github.com/hamza-topo/boxnot"
    }
  }
];

export default projects;
